import React, { useState, useEffect } from "react";

const EditSubtaskNameModal = ({ isOpen, onClose, onSave, initialName }) => {
    const [name, setName] = useState(initialName);

    useEffect(() => {
        setName(initialName);
    }, [initialName]);

    const handleSave = () => {
        if (name.trim()) {
            onSave(name);
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-[60]">
            <div
                className="bg-white rounded-lg w-full max-w-sm mx-4 p-6 shadow-xl"
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="text-xl font-bold mb-4">Edit Subtask Name</h2>
                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleSave();
                        }
                    }}
                    className="w-full p-2 border border-gray-300 rounded mb-4 focus:outline-none focus:border-purple-500"
                    autoFocus
                />
                <div className="flex justify-end space-x-2">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSave}
                        className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditSubtaskNameModal;
